import React from 'react';

import {
  useGetDashboardVerificationRequestsCountGroupedByStatusQuery,
  VerificationRequestStatus,
} from 'src/api';
import { OverviewManualRequestsActivity } from 'src/types/dashboard';

import { useDashboardCVAdminData } from './useDashboardCVAdminData';

export const useOverviewManualRequestsActivity = () => {
  const { date, employers, peos } = useDashboardCVAdminData();

  const { data, loading } = useGetDashboardVerificationRequestsCountGroupedByStatusQuery({
    variables: {
      asOfDate: date.toISO(),
      peoIds: peos?.map(peo => peo.id),
      employerIds: employers?.map(employer => employer.id),
    },
  });

  const manualRequestActivity = React.useMemo(() => {
    const result: OverviewManualRequestsActivity = {
      approved: 0,
      declined: 0,
      pending: 0,
    };

    for (const group of data?.getDashboardVerificationRequestsCountGroupedByStatus ?? []) {
      switch (group.status) {
        case VerificationRequestStatus.ReviewedByVerifier:
        case VerificationRequestStatus.ReportCreated:
          result.approved += group.count;
          break;
        case VerificationRequestStatus.DeclinedByEmployee:
          result.declined += group.count;
          break;
        case VerificationRequestStatus.EmployeeToRespond:
          result.pending += group.count;
          break;
        default:
          break;
      }
    }

    return result;
  }, [data]);

  return { manualRequestActivity, manualRequestActivityLoading: loading };
};
